import { parsePSSERawFile } from './psseParser';
import { convertPSSEToGridState } from './psseConverter';
import { GridState } from '../types';

/**
 * Parse a PSSE raw file string and return a GridState with automatic layout
 * @param rawFileContent - The PSSE raw file content as a string
 * @returns GridState with positioned nodes and edges
 */
export function loadPSSESystem(rawFileContent: string): GridState {
  // Parse the raw PSSE data
  const psseData = parsePSSERawFile(rawFileContent);
  
  // Convert to basic grid state
  const baseGridState = convertPSSEToGridState(psseData);
  
  return baseGridState;
}
